import { getMainEnv } from '@orionprotocol/env';

 
import { reportToSentry } from '../utils';

import { createMixpanelAnalytics } from './mixpanel';
import { Analytics } from './Analytics';

export const analyticsService: Analytics = createMixpanelAnalytics({
   
  app_key: getMainEnv()?.VITE_MIXPANEL_API_KEY,
  url: 'https://mixpanel-proxy.orion.xyz/',
  onInitError(error) {
    reportToSentry(error);
  },
});
